// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================================
   Users List Skeleton — mirrors mat-table layout
   ========================================================= */

.skl-users-list {
  width: 100%;
}

.skl-table-wrap {
  width: 100%;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  background: #fff;
  overflow-x: auto;
}

.skl-row {
  display: flex;
  align-items: center;
  min-width: max-content;
  width: 100%;
}

.skl-header-row {
  background: #f8f9fa;
  border-bottom: 2px solid #dee2e6;
  min-height: 48px;
}

.skl-data-row {
  border-bottom: 1px solid #f0f0f0;
  min-height: 44px;
}

.skl-data-row:last-child {
  border-bottom: none;
}

.skl-cell {
  flex: 1;
  padding: 0 12px;
  overflow: hidden;
}

.skl-paginator {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 4px;
  border-top: 1px solid #dee2e6;
}
`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/admin/users-list/users-list-skeleton/users-list-skeleton.component.css"],"names":[],"mappings":"AAAA;;8DAE8D;;AAE9D;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;AAC/B","sourcesContent":["/* =========================================================\n   Users List Skeleton — mirrors mat-table layout\n   ========================================================= */\n\n.skl-users-list {\n  width: 100%;\n}\n\n.skl-table-wrap {\n  width: 100%;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  background: #fff;\n  overflow-x: auto;\n}\n\n.skl-row {\n  display: flex;\n  align-items: center;\n  min-width: max-content;\n  width: 100%;\n}\n\n.skl-header-row {\n  background: #f8f9fa;\n  border-bottom: 2px solid #dee2e6;\n  min-height: 48px;\n}\n\n.skl-data-row {\n  border-bottom: 1px solid #f0f0f0;\n  min-height: 44px;\n}\n\n.skl-data-row:last-child {\n  border-bottom: none;\n}\n\n.skl-cell {\n  flex: 1;\n  padding: 0 12px;\n  overflow: hidden;\n}\n\n.skl-paginator {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 4px;\n  border-top: 1px solid #dee2e6;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
